/* tslint:disable */
/* eslint-disable */
/**
 * InnerAnalytics MNT Server
 * InnerAnalytics MNT server API specification.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface TdeeCalculateRequest
 */
export interface TdeeCalculateRequest {
    /**
     * 
     * @type {number}
     * @memberof TdeeCalculateRequest
     */
    'age_years': number;
    /**
     * 
     * @type {number}
     * @memberof TdeeCalculateRequest
     */
    'weight_kg': number;
    /**
     * 
     * @type {number}
     * @memberof TdeeCalculateRequest
     */
    'height_cm': number;
    /**
     * 
     * @type {string}
     * @memberof TdeeCalculateRequest
     */
    'sex': TdeeCalculateRequestSexEnum;
    /**
     * 
     * @type {string}
     * @memberof TdeeCalculateRequest
     */
    'activity_level': TdeeCalculateRequestActivityLevelEnum;
}

export const TdeeCalculateRequestSexEnum = {
    Male: 'male',
    Female: 'female'
} as const;

export type TdeeCalculateRequestSexEnum = typeof TdeeCalculateRequestSexEnum[keyof typeof TdeeCalculateRequestSexEnum];
export const TdeeCalculateRequestActivityLevelEnum = {
    Sedentary: 'sedentary',
    LightlyActive: 'lightly_active',
    ModeratelyActive: 'moderately_active',
    VeryActive: 'very_active',
    ExtraActive: 'extra_active'
} as const;

export type TdeeCalculateRequestActivityLevelEnum = typeof TdeeCalculateRequestActivityLevelEnum[keyof typeof TdeeCalculateRequestActivityLevelEnum];


